export const StatusLoading = () => {
    return <>Loading</>
}